var _circle, _circle2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircle2Inline = function SvgCircle2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 32,
    fill: "url(#circle-2_inline_svg__a)",
    stroke: "#fff",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 32,
    fill: "#7D64FF",
    stroke: "#fff",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.302 36.001c0-7.566 6.133-13.7 13.7-13.7 7.566 0 13.7 6.134 13.7 13.7 0 7.567-6.134 13.7-13.7 13.7-7.567 0-13.7-6.133-13.7-13.7Zm13.7-16.3c-9.003 0-16.3 7.298-16.3 16.3s7.297 16.3 16.3 16.3c9.002 0 16.3-7.298 16.3-16.3s-7.298-16.3-16.3-16.3Zm-1.304 9.296v5.7h-5.7v2.6h5.7v5.7h2.6v-5.7h5.7v-2.6h-5.7v-5.7h-2.6Z",
    fill: "url(#circle-2_inline_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-2_inline_svg__a",
    x1: 7.983,
    y1: 7.931,
    x2: 64.007,
    y2: 63.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#C055F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#8B55F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#3C72DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-2_inline_svg__b",
    x1: 36.003,
    y1: 19.998,
    x2: 36.003,
    y2: 51.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#fff",
    stopOpacity: 0.8
  })))));
};
export default SvgCircle2Inline;